<template>
  <!-- 活动报名 -->
  <div class="eventRegistration">
    <van-nav-bar :title="'活动报名'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true" />
    <div class="content">
      <van-pull-refresh v-model="isLoadingAwait"
                        @refresh="onRefreshAwait">
        <van-list v-model="loadingAwait"
                  :finished="finishedAwait"
                  :finished-text="$t('module.noMore')"
                  @load="onLoadAwait">
          <div class="event_box"
               v-for="(item,idx) in assessList"
               :key="idx">
            <div class="event_top"
                 :class="!item.can_enroll?'nofooter_top':''">
              <div class="event_title">
                <div class="title">{{item.at_subject}}</div>
              </div>
              <div class="event_body">
                <div class="cell">{{item.at_bd_ed}}</div>
                <div class="cell">{{item.at_address_location}}</div>
                <div class="cell">{{item.enroll_bd_ed}}</div>
                <div class="cell">{{item.at_charge_name_phone}}</div>
              </div>
              <img v-if="item.is_enroll_competitor"
                   style="width: 75px"
                   src="@assets/img/yibaoming.png"
                   class="img1" />
            </div>
            <div class="footer"
                 @click="checkDetails(item)">查看详情</div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { getActivityList, activityEnroll } from '@api/integral.js'
export default {
  data () {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      deleteAss: require('@/assets/img/deleteAss.png'),
      isLoadingAwait: false,
      loadingAwait: false,
      finishedAwait: false,
      assessList: [],
      event: {},
      roles: ['a', 'b'],
    }
  },
  created () {
    this.getMyActivities()
  },
  methods: {
    // 查看详情
    checkDetails (item) {
      this.$router.push({
        path: '/eventDetails',
        query: { from: 'signUp', autoid: item.autoid, parents: this.$route.query.from }
      })
    },
    // 报名
    // goToRegister (item) {
    //   // 已经报名
    //   if (item.is_enroll_competitor)
    //   {
    //     return
    //   }
    //   let params = {
    //     autoid: item.autoid,
    //     enroll_typeid: 0,
    //     at_plan_id: 0,
    //     username: this.userInfo.username
    //   }
    //   Dialog.confirm({
    //     title: this.$t('module.systemhint'),
    //     message: '您确定要报名参赛吗？',
    //   }).then(() => {
    //     activityEnroll(params).then(res => {
    //       if (res.data[0].info)
    //       {
    //         Toast.fail(res.data[0].info);
    //       } else
    //       {
    //         Toast.success(this.$t('module.submitScu'));
    //         this.getMyActivities()
    //       }
    //     })
    //   }).catch(() => {
    //     // on cancel
    //   });
    // },
    onLoadAwait () {
      // 异步更新数据
      if (this.isLoadingAwait)
      {
        this.assessList = []
        this.isLoadingAwait = false
      }
      this.getMyActivities()
    },
    onRefreshAwait () {
      this.assessList = []
      this.finishedAwait = false
      this.loadingAwait = true
      this.onLoadAwait()
      Toast(this.$t('module.refreshSuccessfully'))
    },
    // 获取活动列表
    getMyActivities () {
      getActivityList({
        flag: 0,
        username: this.userInfo.username
      }).then(res => {
        if (res.data.length == 0)
        {
          this.finishedAwait = true
          // 无数据
        } else
        {
          this.assessList = res.data
          this.loadingAwait = false
          this.finishedAwait = true
        }
      })
    },
    // 返回
    onClickLeft () {
      if (this.$route.query.from == 'home')
      {
        this.$router.push('/home')
      } else
      {
        this.$router.push('/personCen')
      }
    },
  }
}
</script>

<style lang="less" scoped>
.eventRegistration {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;

    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .content {
    // overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .van-pull-refresh {
      height: 100%;
      overflow: auto;
      padding: 20px;
      .van-list {
        .event_box {
          margin-bottom: 40px;
          .event_top {
            position: relative;
            background: #ffffff;
            padding: 30px 20px;
            border-radius: 40px 40px 0 0;
            img {
              position: absolute;
              bottom: 0;
              right: 0;
            }
            .event_title {
              margin-bottom: 20px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .title {
                font-size: 40px;
                font-weight: bold;
                // color: #6ecaf2;
                color: #42baed;
              }
              .button {
                display: flex;
                padding: 14px 30px;
                color: #ffffff;
                font-size: 28px;
                border-radius: 30px;
                background: #5287ef;
              }
            }
            .event_body {
              font-size: 30px;
              .cell {
                margin: 20px 10px;
              }
            }
          }
          .nofooter_top {
            border-radius: 40px;
          }
          .footer {
            padding: 20px 0;
            font-size: 36px;
            color: #ffffff;
            background: #437ced;
            text-align: center;
            border-radius: 0 0 40px 40px;
          }
          .noclickFooter {
            opacity: 0.5;
          }
        }
      }
    }
  }
}
</style>